<!--  -->
<template>
  <div class="resultsPageContent">
    <div class="completed_logo">
      <img width="100%" height="100%" :src="imgSrc" />
    </div>
      <slot name="default">
        <p class="instructions">{{instructions}}</p>
      </slot>
    <div class="operation" v-if="operationDisplab">
      <van-button
        type="primary"
        class="operation_btn"
        @click="handleOperationClick"
      >{{operationText}}</van-button>
    </div>
    <div class="return" v-if="returnDisplab">
      <van-button type="primary" class="return_btn" @click="handleReturnClick">{{returnText}}</van-button>
    </div>
  </div>
</template>



<script>
export default {
  name: "resultsPage",
  data() {
    return {};
  },
  props: {
    operationDisplab: {
      //按钮1是否显示
      type: Boolean,
      default: true,
    },
    operationText: {
      //按钮1文案
      type: String,
      default: "查看",
    },
    returnDisplab: {
      //按钮2是否显示
      type: Boolean,
      default: true,
    },
    returnText: {
      //按钮2文案
      type: String,
      default: "返回",
    },
    instructions: {
      //回执说明
      type: String,
      default: "已成功",
    },
    imgSrc: {
      type: String,
      default: require("../../../assets/debtor/resultOk.png"),
    },
  },
  computed: {},
  methods: {
    handleOperationClick() {
      //按钮1绑定事件
      this.$emit("handleOperationClick");
    },
    handleReturnClick() {
      //按钮2绑定事件
      this.$emit("handleReturnClick");
    },
  },
};
</script>

<style scoped lang='less'>
.resultsPageContent {
  text-align: center;
  margin-top: 10px;
  background: #fff;
  padding-bottom: 40px;
  .completed_logo {
    width: 53px;
    height: 53px;
    margin: 0 auto;
    padding: 40px 0 20px;
  }
  .instructions {
    margin-bottom: 36px;
    font-size: 15px;
  }
  .operation {
    margin: 0 33px;
  }
  .operation_btn {
    width: 100%;
    height: 50px;
    font-size: 17px;
    display: block;
    border-radius: 30px;
    line-height: 50px;
    font-weight: 600;
    background-color: #fc740c;
    color: #fff;
    border: none;
  }
  .return {
    margin: 15px 33px 0;
  }
  .return_btn {
    background-color: #fff;
    color: #333;
    border: 1px solid #333;
    width: 100%;
    margin: 0 auto;
    height: 50px;
    font-size: 17px;
    display: block;
    border-radius: 30px;
    line-height: 50px;
    font-weight: 600;
  }
}
</style>
